import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import "@radix-ui/themes/styles.css";
import { Theme } from '@radix-ui/themes';
import { Provider } from 'react-redux';
import store from './core/store'
import { BrowserRouter } from 'react-router-dom';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}> 
    	<Theme appearance= 'light'>
        <BrowserRouter> 
					<App />
          </BrowserRouter>
				</Theme>
        </Provider>
  
);

